import { useChatPanelFiles } from "@ext/agent/components/hooks/useChatPanelFiles";
import { ChatSessionError } from "../message/ChatSessionError";
import { MessageList } from "../message/MessageList";
import { ChatFooter } from "./ChatFooter";

export const ChatShell = () => {
	const { attach, isDragging, panelProps } = useChatPanelFiles();

	return (
		<div
			className="relative flex h-full w-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden outline-none"
			tabIndex={-1}
			{...panelProps}
		>
			<ChatSessionError />

			<MessageList />

			<ChatFooter attach={attach} />

			{isDragging && (
				<div className="pointer-events-none absolute inset-0 z-10 rounded-2xl border border-dashed border-muted bg-alpha-high-90" />
			)}
		</div>
	);
};
